import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import Home from './Home';
import AboutUs from './AboutUs';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Products from './Products';
import ProductDetails from './ProductDetails';
import Gallery from './Gallery';
import ContactUs from './ContactUs';
import AdminLogin from './AdminLogin';
import AdminPortal from './AdminPortal';
import AddEditProducts from './AddEditProducts';
import ManageOrders from './ManageOrders';
import ManageProducts from './ManageProducts';
import ManageTestimonials from './ManageTestimonials';
import ManageBrands from './ManageBrands';
import ManageShippingFees from './ManageShippingFees';
import CheckOut from './CheckOut';
import Cart from './Cart';
import OrderSuccess from './OrderSuccess';
import OrderDetails from './OrderDetails';
import CustomerOrderDetails from './CustomerOrderDetails';
import Invoice from './Invoice';
import CheckOrderStatus from './CheckOrderStatus';
import ScrollToTop from './ScrollToTop';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<App><Home /></App>} />
        <Route path="/about" element={<App><AboutUs /></App>} />
        <Route path="/products" element={<App><Products /></App>} />
        <Route path="/products/:id" element={<App><ProductDetails /></App>} />
        <Route path="/checkout/:id" element={<App><CheckOut /></App>} />
        <Route path="/checkout" element={<App><CheckOut /></App>} />
        <Route path="/cart" element={<App><Cart /></App>} />
        <Route path="/order-success" element={<App><OrderSuccess /></App>} />
        <Route path="/order/:orderId" element={<App><OrderDetails /></App>} />
        <Route path="/customer-order/:orderId" element={<App><CustomerOrderDetails /></App>} />
        <Route path="/invoice/:orderId" element={<App><Invoice /></App>} />
        <Route path="/check-order-status" element={<App><CheckOrderStatus /></App>} />
        <Route path="/testimonials" element={<App><Gallery /></App>} />
            <Route path="/contact" element={<App><ContactUs /></App>} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin-portal" element={<AdminPortal />} />
            <Route path="/admin-portal/products" element={<ManageProducts />} />
            <Route path="/admin-portal/testimonials" element={<ManageTestimonials />} />
            <Route path="/admin-portal/brands" element={<ManageBrands />} />
            <Route path="/admin-portal/add" element={<AddEditProducts />} />
            <Route path="/admin-portal/edit/:id" element={<AddEditProducts />} />
            <Route path="/admin-portal/orders" element={<ManageOrders />} />
            <Route path="/admin-portal/shipping-fees" element={<ManageShippingFees />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
